module.exports = __webpack_public_path__ + "static/media/ic_pet6.b6e1382f.png";